import '@mdi/font/css/materialdesignicons.css'
import '@/stylesheets/Fonts.scss'

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from "@/store";
import {LocaleApi} from "@swagger";
import VueI18n from "vue-i18n";
import Vuetify from "vuetify";
import VueCookie from "vue-cookie";
import {VueMasonryPlugin} from "vue-masonry";
import BasicComponent, {getApiUrl} from "@/global/BasicComponent";

Vue.config.productionTip = false;

Vue.use(Vuetify);

const vuetify = new Vuetify(
    {
        options: {
            customProperties: true
        },
        theme: {
            themes: {
                light: {
                    primary: '#bdcf17',
                    secondary: '#b1c300',
                    accent: '#8a9100',
                    error: '#FF5252',
                    info: '#2196F3',
                    success: '#4CAF50',
                    warning: '#FFC107'
                }
            }
        }
    }
);

Vue.use(VueCookie);
Vue.use(VueI18n);
Vue.use(VueMasonryPlugin);
Vue.mixin(BasicComponent);

new LocaleApi({
    basePath: getApiUrl(),
}).getMessages()
    .then((data) => {

        const messages = {
            de: data
        };

        const i18n = new VueI18n({
            locale: "de",
            messages
        });

        var vm = new Vue({
            vuetify,
            router,
            store,
            i18n,
            render: h => h(App)
        }).$mount('#app');

    })
    .catch((err) => {
        if (err.json) err.json().then(error => {
            console.error(error)
        });
        else console.error(err);
    });



